import { useEffect, useState } from "react";
import { useLenis } from "@/hooks/useLenis";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { AboutHor } from "@/components/AboutHor";
import { LineupSection } from "@/components/LineupSection";
import { EventDetails } from "@/components/EventDetails";
import { FinalCta } from "@/components/FinalCta";
import { Footer } from "@/components/Footer";
import { StickyCTA } from "@/components/StickyCTA";
import { HalloweenDivider } from "@/components/HalloweenDivider";
import { Seo } from "@/components/Seo";
import { ARTISTS } from "@/data/events";

export const EventPage = ({ event }) => {
  useLenis();
  const [showSticky, setShowSticky] = useState(false);
  const artists = ARTISTS;

  useEffect(() => {
    const onScroll = () => setShowSticky(window.scrollY > window.innerHeight * 0.8);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const marqueeText = `HÖR BERLIN ON TOUR — HALLOWEEN EDITION 2026 — ${event.city.toUpperCase()} — ${event.dateLabel.toUpperCase()} — BIIA — TIGERHEAD — DØMINA — TICKETS FROM ₹999 — `;

  return (
    <div data-testid={`event-page-${event.citySlug}`} className="bg-black min-h-screen">
      <Seo title={event.seoTitle} description={event.seoDescription} event={event} />
      <Header event={event} />
      <Hero event={event} artists={artists} />
      <Marquee text={marqueeText} />
      <AboutHor />
      <HalloweenDivider />
      <LineupSection artists={artists} />
      <EventDetails event={event} />
      <HalloweenDivider color="bg-acid" />
      <FinalCta event={event} />
      <Footer event={event} />
      {showSticky && <StickyCTA event={event} />}
    </div>
  );
};
